var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", { attrs: { "data-vv-scope": "step-1" } }, [
    _c("div", { staticClass: "row mb-3 mt-2" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("vs-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            staticClass: "w-100",
            attrs: {
              label: "Título",
              "data-vv-as": "titulo",
              name: "title",
              danger: _vm.errors.has("step-1.title"),
              "danger-text": _vm.errors.first("step-1.title"),
              success:
                !_vm.errors.has("step-1.title") && _vm.step.title.length > 0
            },
            model: {
              value: _vm.step.title,
              callback: function($$v) {
                _vm.$set(_vm.step, "title", $$v)
              },
              expression: "step.title"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("list-document-types", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            ref: "documentTypes",
            staticClass: "w-100",
            attrs: {
              autocomplete: "",
              label: "Tipo Documento (*)",
              name: "documentType",
              danger: _vm.errors.has("step-1.documentType"),
              "danger-text": _vm.errors.first("step-1.documentType")
            },
            model: {
              value: _vm.step.documentType,
              callback: function($$v) {
                _vm.$set(_vm.step, "documentType", $$v)
              },
              expression: "step.documentType"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [
          _c("list-documents", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: _vm.isRequired },
                expression: "{'required': isRequired}"
              }
            ],
            ref: "documents",
            staticClass: "w-100",
            attrs: {
              "type-numeration": _vm.typeNumeration,
              autocomplete: "",
              label: "Documento (*)",
              name: "document",
              "parent-value": _vm.step.documentType,
              danger: _vm.errors.has("step-1.document"),
              "danger-text": _vm.errors.first("step-1.document")
            },
            model: {
              value: _vm.step.document,
              callback: function($$v) {
                _vm.$set(_vm.step, "document", $$v)
              },
              expression: "step.document"
            }
          })
        ],
        1
      )
    ]),
    _vm.step.documentType === "IPCAFTO"
      ? _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "vs-select",
                {
                  staticClass: "w-100",
                  attrs: {
                    label: "Estado de la propuesta",
                    placeholder: "Seleccione..."
                  },
                  model: {
                    value: _vm.step.proposalStatus,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "proposalStatus", $$v)
                    },
                    expression: "step.proposalStatus"
                  }
                },
                [
                  _c("vs-select-item", {
                    attrs: { value: "published", text: "Publicado" }
                  }),
                  _c("vs-select-item", {
                    attrs: { value: "processed", text: "Tramitado" }
                  }),
                  _c("vs-select-item", {
                    attrs: { value: "rejected", text: "Rechazado" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: { label: "Cantidad de Adhesiones" },
                model: {
                  value: _vm.step.adhesion,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "adhesion", $$v)
                  },
                  expression: "step.adhesion"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "vs-select",
            {
              staticClass: "w-100",
              attrs: {
                autocomplete: "",
                label: "Formato Documento",
                name: "formatDocument"
              },
              model: {
                value: _vm.step.formatDocument,
                callback: function($$v) {
                  _vm.$set(_vm.step, "formatDocument", $$v)
                },
                expression: "step.formatDocument"
              }
            },
            [
              _c("vs-select-item", { attrs: { value: 0, text: "Papel" } }),
              _c("vs-select-item", { attrs: { value: 1, text: "Electrónico" } })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("label", [_vm._v("Materia")]),
          _c("treeselect", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              placeholder: "Seleccione...",
              options: _vm.ontologies,
              "data-vv-as": "materia",
              name: "matter"
            },
            model: {
              value: _vm.step.matter,
              callback: function($$v) {
                _vm.$set(_vm.step, "matter", $$v)
              },
              expression: "step.matter"
            }
          })
        ],
        1
      ),
      _vm.errors.has("step-1.matter")
        ? _c("small", { staticClass: "ml-4 text-danger" }, [
            _vm._v(" " + _vm._s(_vm.errors.first("step-1.matter")) + " ")
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "row mb-3 mt-2" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("label", [_vm._v("Palabras clave")]),
          _c("Keywords", {
            model: {
              value: _vm.step.tags,
              callback: function($$v) {
                _vm.$set(_vm.step, "tags", $$v)
              },
              expression: "step.tags"
            }
          })
        ],
        1
      )
    ]),
    _vm.step.documentType === "IPCAFTO"
      ? _c("div", { staticClass: "row mb-3 mt-2" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("label", [_vm._v("Comisiones")]),
              _c("treeselect", {
                attrs: {
                  placeholder: "Seleccione",
                  options: _vm.interestAreas
                },
                model: {
                  value: _vm.step.commissions,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "commissions", $$v)
                  },
                  expression: "step.commissions"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "row mb-3 mt-2" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("label", [_vm._v("Acceso")]),
          _c("b-form-select", {
            staticClass: "w-100",
            attrs: { options: _vm.access },
            model: {
              value: _vm.step.accessRights,
              callback: function($$v) {
                _vm.$set(_vm.step, "accessRights", $$v)
              },
              expression: "step.accessRights"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c(
            "b-form-group",
            [
              _c("label", [_vm._v("Fecha de despacho")]),
              _c("b-form-datepicker", {
                staticClass: "form-control bg-white",
                attrs: {
                  "reset-button": "",
                  "label-reset-button": "Limpiar fecha",
                  "hide-header": "",
                  "show-decade-nav": "",
                  "start-weekday": "1",
                  name: "deliveryDate",
                  placeholder: "Seleccione...",
                  locale: "es"
                },
                model: {
                  value: _vm.step.deliveryDate,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "deliveryDate", $$v)
                  },
                  expression: "step.deliveryDate"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }